import { StatusColorIndicator } from '@adsk/bim360-matrix-react-components';

export const STATUS_DRAFT = 'draft';
export const STATUS_SUBMITTED = 'submitted';
export const STATUS_OPEN = 'open';
export const STATUS_FORWARD = 'forward';
export const STATUS_ANSWERED = 'answered';
export const STATUS_CLOSED = 'closed';
export const STATUS_REJECTED = 'rejected';
export const STATUS_VOID = 'void';

export const RFIS_SORTED_STATUSES = [
  STATUS_DRAFT,
  STATUS_SUBMITTED,
  STATUS_OPEN,
  STATUS_ANSWERED,
  STATUS_REJECTED,
  STATUS_CLOSED,
  STATUS_VOID,
];

export const STATUS_OPEN_REV1 = 'openRev1';
export const STATUS_OPEN_REV2 = 'openRev2';
export const STATUS_ANSWERED_MANAGER = 'answeredManager';
export const STATUS_REJECTED_MANAGER = 'rejectedManager';
export const STATUS_ANSWERED_REV1 = 'answeredRev1';
export const STATUS_REJECTED_REV1 = 'rejectedRev1';

export const RFIS_INNER_STATUSES = [STATUS_OPEN_REV1, STATUS_OPEN_REV2, ...RFIS_SORTED_STATUSES];

export const statusColorMapping = {
  [STATUS_DRAFT]: StatusColorIndicator.Colors.GRAY_DARK,
  [STATUS_SUBMITTED]: StatusColorIndicator.Colors.PURPLE,
  [STATUS_OPEN]: StatusColorIndicator.Colors.YELLOW,
  [STATUS_FORWARD]: StatusColorIndicator.Colors.YELLOW,
  [STATUS_ANSWERED]: StatusColorIndicator.Colors.BLUE,
  [STATUS_REJECTED]: StatusColorIndicator.Colors.RED,
  [STATUS_CLOSED]: StatusColorIndicator.Colors.GRAY,
  [STATUS_VOID]: StatusColorIndicator.Colors.GRAY,
};
